import React from 'react';
import {
  MARK_BOLD,
  MARK_CODE,
  MARK_ITALIC,
  MARK_LINK,
  MARK_STRIKE,
  MARK_STYLED,
  MARK_UNDERLINE,
} from 'storyblok-rich-text-react-renderer';

import Link, { withUnderlineCss } from '../Link/Link';
import Typography from '../../components/Typography/Typography';
import { Type } from '../Type/Type';

const MarkupBold = (children) => <Type as="strong">{children}</Type>;

const MarkupCode = (children) => <Type as="code">{children}</Type>;

const MarkupItalic = (children) => <Type as="em">{children}</Type>;

const MarkupLink = (children, { linktype, href, target }) => (
  <Link linktype={linktype} href={href} target={target}>
    <Typography
      // If we have an underlined element we hide underline animation
      css={children?.props?.component === 'u' ? undefined : withUnderlineCss}
      inline
      variant="link"
    >
      {children}
    </Typography>
  </Link>
);

const MarkupStrike = (children) => <Type as="s">{children}</Type>;

const MarkupStyled = (children, { class: className }) => (
  <Type as="span" className={className}>
    {children}
  </Type>
);

const MarkupUnderline = (children) => <Type as="u">{children}</Type>;

const markResolvers = {
  [MARK_BOLD]: MarkupBold,
  [MARK_CODE]: MarkupCode,
  [MARK_ITALIC]: MarkupItalic,
  [MARK_LINK]: MarkupLink,
  [MARK_STRIKE]: MarkupStrike,
  [MARK_STYLED]: MarkupStyled,
  [MARK_UNDERLINE]: MarkupUnderline,
};

export default markResolvers;
